import React, { useState } from 'react';
import { Box, Button, Link, Popover, Stack, Typography } from '@mui/material';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { APP_CONSTANTS, CBI_SUPPORT, DEFAULT_SUPPORT_CONTACT, IOB_SUPPORT } from '../URLConstants';
import { useAuth } from './customContextProviders/AuthContext';

export default function ContactSupportButton() {
  const { userLoginOrg } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  let contact = DEFAULT_SUPPORT_CONTACT;

  switch (userLoginOrg) {
    case APP_CONSTANTS.CBI_CLIENT_IDENTIFIER:
      contact = CBI_SUPPORT;
      break;

    case APP_CONSTANTS.IOB_CLIENT_IDENTIFIER:
      contact = IOB_SUPPORT;
      break;

    default:
      contact = DEFAULT_SUPPORT_CONTACT;
  }

  return (
    <>
      {(userLoginOrg === APP_CONSTANTS.CBI_CLIENT_IDENTIFIER ||
        userLoginOrg === APP_CONSTANTS.IOB_CLIENT_IDENTIFIER) && (
        <Button
          variant="contained"
          color="whitebg"
          size="small"
          sx={{ minHeight: '5vh', mr: 2, mb: 1, minWidth: 120 }}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={(e) => setAnchorEl(e.currentTarget)}
          data-cy="contact-support-button"
        >
          Contact Support
        </Button>
      )}

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: {
            elevation: 8,
            sx: {
              mt: 1,
              borderRadius: 2,
              boxShadow: '0px 8px 24px rgba(23, 29, 64, 0.12)',
              overflow: 'visible'
            }
          }
        }}
      >
        <Box
          data-cy="contact-support-popover"
          sx={{ px: 2.5, py: 2, minWidth: 260, maxWidth: 320 }}
        >
          <Typography
            variant="caption"
            sx={{
              display: 'block',
              color: 'text.secondary',
              fontWeight: 500,
              letterSpacing: 0.2,
              mb: 1.5
            }}
          >
            Support Contact
          </Typography>

          <Stack spacing={1.75}>
            <Stack direction="row" spacing={1.25} alignItems="center">
              <PhoneOutlinedIcon sx={{ color: 'grey.600', fontSize: 22, flexShrink: 0 }} />
              <Link
                href={contact?.phoneHref}
                underline="hover"
                color="inherit"
                sx={{ fontSize: 14, fontWeight: 500, color: 'text.primary' }}
              >
                {contact?.phone}
              </Link>
            </Stack>

            <Stack direction="row" spacing={1.25} alignItems="center">
              <EmailOutlinedIcon sx={{ color: 'grey.600', fontSize: 22, flexShrink: 0 }} />
              <Link
                href={`mailto:${contact?.email}`}
                underline="hover"
                color="inherit"
                sx={{ fontSize: 14, fontWeight: 500, color: 'text.primary' }}
              >
                {contact?.email}
              </Link>
            </Stack>
          </Stack>
        </Box>
      </Popover>
    </>
  );
}
